import API from '../api';

export const getQuestionsByInterview = ({
  params: { page, uuid, page_size, question } = {},
  signal,
} = {}) => API.get(`/interviews/interviews/${uuid}/questions/`, {
  params: { page, page_size, question },
  signal,
}).then((res) => res?.data);

export const getInterviews = ({ params = {}, signal } = {}) => {
  const { uuid, ...query } = params;
  return API.get(`/interviews/interviews/${uuid ? `${uuid}/` : ''}`, {
    params: query,
    signal,
  }).then((response) => response.data);
};

export const getInterview = (uuid, { signal } = {}) =>
  getInterviews({ params: { uuid }, signal });

export const getInterviewAdminSummary = ({ signal } = {}) =>
  API.get('/interviews/interviews/admin_summary/', { signal }).then(
    (response) => response.data,
  );

export const getVideoStatus = ({ params: { uuid } = {} } = {}) => {
  return new Promise((resolve, reject) => {
    try {
      API.get(`/interviews/interviews/${uuid}/video_generation_status`)
        .then((res) => {
          resolve(res?.data);
        })
        .catch((err) => {
          reject('axios error', err);
        });
    } catch (error) {
      reject('system error', error);
    }
  });
};

export const generateAIVideos = ({ params: { uuid } = {} } = {}) => {
  return new Promise((resolve, reject) => {
    try {
      API.post(`/interviews/interviews/${uuid}/generate_videos/`)
        .then((res) => {
          resolve(res?.data);
        })
        .catch((err) => {
          reject('axios error', err);
        });
    } catch (error) {
      reject('system error', error);
    }
  });
};

export const postInterview = ({ name, description, type, template, skills } = {}) => {
  return new Promise((resolve, reject) => {
    try {
      API.post('/interviews/interviews/', { name, description, type, template: template || null, skills: skills || [] })
        .then((res) => {
          resolve(res?.data);
        })
        .catch((err) => {
          reject('axios error', err);
        });
    } catch (error) {
      reject('system error', error);
    }
  });
};

export const patchInterview = (uuid, body) =>
  API.patch(`/interviews/interviews/${uuid}/`, body).then((res) => res?.data);

export const deleteInterview = (uuid) =>
  API.delete(`/interviews/interviews/${uuid}/`).then((res) => res?.data);

export const generateInterviewVideos = ({ params: { uuid } = {} } = {}) => {
  return new Promise((resolve, reject) => {
    try {
      API.post(`/interviews/interviews/${uuid}/generate_interview_videos/`)
        .then((res) => {
          resolve(res?.data);
        })
        .catch((err) => {
          reject('axios error', err);
        });
    } catch (error) {
      reject('system error', error);
    }
  });
};

export const getInterviewVideoStatus = ({ params: { uuid } = {} } = {}) => {
  return new Promise((resolve, reject) => {
    try {
      API.get(
        `/interviews/interviews/${uuid}/interview_video_generation_status`,
      )
        .then((res) => {
          resolve(res?.data);
        })
        .catch((err) => {
          reject('axios error', err);
        });
    } catch (error) {
      reject('system error', error);
    }
  });
};
